<script>
    import randomColor from "randomcolor";
    import { createEventDispatcher, onMount } from 'svelte';

    export let size = "100%";
    export let round = true;
    export let values = [{color: "#CCC", value: 100}];
    export let center = false;
    export let style = "";
    export let percent;

    const PALETTE = randomColor({
        count: 25,
        luminosity: 'bright',
        format: 'rgba',
        alpha: 0.9
    });

    function valueToPercent(value, total) {
        return 100 / (total / value);
    }

    $: totalValue = values.reduce((result, {value}) => result + value, 0);

    $: parsedAbs = values.map(({color, value}, index) => {
        return {
            color: color || PALETTE[index],
            percentAbs: valueToPercent(value, totalValue)
        }
    });

    $: parsedCumul = parsedAbs.map((obj, index) => {
        let prevAbs = (index > 0) ? parsedAbs[index-1].percentAbs : 0;
        return {...obj, ...{
            percentCumul: prevAbs + obj.percentAbs
        }};
    });

    $: rules = parsedCumul.map(({percentCumul, color}, index) => {
        return (index < values.length-1)
            ? `${color} 0 ${percentCumul}%`
            : `${color} 0`;
    });

    $: {
        console.log(`parsedAbs: `);
        console.log(parsedAbs);
        console.log(`parsedCumul: `);
        console.log(parsedCumul);
        console.log(`rules: `);
        console.log(rules);
    }

    $: gradient = new ConicGradient({
        stops: rules.join(",")
    });
</script>

<div class="pie" class:round class:center style="height: {size}; width: {size}; {style}">
    {#if values}
        {@html gradient.svg}
    {/if}

    {#if percent && values && values.length > 1}
        <div class="percent">
<!--            {percent.toFixed(2)}%-->
        </div>
    {/if}
</div>

<style>
    .pie {
        overflow: hidden;
        position: relative;
    }

    .pie.center {
        margin: auto;
    }

    .pie .percent {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        flex-orientation: column;
        justify-content: center;
        align-items: center;
        top: 0;
        font-weight: bold;
    }

    :global(.pie.round > svg) {
        border-radius: 1000px;
        width: 100%;
        height: 100%;
    }
</style>